<template>
    <div class="common-loading-wrapper" v-if="show">
        <van-overlay z-index="999" class-name="common-overlay-loading" :show="show">
            <div class="loading-box-wrapper" @click.stop>
                <div class="loading-box-block">
                    <van-loading color="#fff" />
                </div>
            </div>
        </van-overlay>
    </div>
</template>

<script>
export default {
    data() {
        return {
            show: false
        };
    },
    created() {

    },
    mounted() {

    },
    methods: {

    }
};
</script>

<style lang="less" scoped>
.common-overlay-loading {
    background-color: transparent;
}
.loading-box-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;

.loading-box-block {
    width: 120px;
    height: 120px;
    border-radius: 20px;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
}
}
</style>
